import { useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import PostApiCall from "./Components/Helpers/PostAPI";
import CustomerDashboard from "./Components/OnlineOrdering/CustomerDashboard/CustomerDashboard";
import Footer from "./Components/OnlineOrdering/Footer/Footer";
import Home from "./Components/OnlineOrdering/Home/Home.js";
import Header from "./Components/OnlineOrdering/Header/Header";
// import PaymentSuccess from "./Components/OnlineOrdering/Payment/PaymentSuccess";
import CancellationRefundPolicyPage from "./Pages/CancellationAndReturnPolicy";
import DisclaimerPage from "./Pages/Disclaimer";
import PrivacyPage from "./Pages/Privacy";
import ShippingDeliveryTermsPage from "./Pages/ShippingAndDeliveryTerms";
import DesignTowTermsConditionPage from "./Pages/TermsAndConditions";
import About from "./Components/OnlineOrdering/Home/Pages/About.js";
import Contact from "./Components/OnlineOrdering/Home/Pages/Contact.js";
import Shop from "./Components/OnlineOrdering/Home/Pages/Shop.js";
import { store } from "./Components/OnlineOrdering/Home/Pages/Store/Store.js";
import ViewInvoiceForm from './Components/OnlineOrdering/Invoice/ViewInvoiceForm.js'
import { ProductProvider } from "./contexts/ProductContext";
import ProductDetail from "./Components/OnlineOrdering/Product/ProductDetail.js";
import GetApiCall from "./Components/OnlineOrdering/helper/GetApi.js";
import { ShopNew } from "./Components/OnlineOrdering/Home/Pages/ShopNew.js";
import { NewCart } from "./Components/NewCartPage/NewCart.js";
import ProtectedRoutes from "./ProtectedRoutes.js";
import PaymentSuccess from "./Components/Payments/PaymentSuccess.js";
import ViewAllOrders from "./Pages/CustomerProfilePage/ViewAllOrders.js"
import CustomerProfilePage from './Pages/CustomerProfilePage/CustomerProfilePage.js'
import { ProductListing } from "./Components/OnlineOrdering/Home/Pages/ProductListing.js";
function App() {
  const {
    setClientDetails,
    setRestaurantOpen,
    setFssai,
    setRestaurantAddress,
    setRestaurantTime,
    setRestaurantName,
    setCurrencyCode,
    setCustomerValidation,
    setClientLogo,
    setClientCredentials,
  } = useContext(store);

  useEffect(() => {
    GetApiCall.getRequest(
      "GetSiteSettingsV1"
    ).then((results) =>
      results?.json().then((obj1) => {
        if (results.status == 200 || results.status == 201) {
          setClientCredentials(obj1?.message1);
          setRestaurantOpen(obj1?.data[0]?.restaurant_open);
          setFssai(obj1?.data[0]?.fld_fssai_number);
          setRestaurantAddress(
            obj1?.data[0]?.fld_address +
            ", " +
            obj1?.data[0]?.city_name +
            ", " +
            obj1?.data[0]?.state_name
          );
          setRestaurantTime(obj1?.data[0]?.res_timings);
          setRestaurantName(obj1?.data[0]?.fld_restaurantname);
          setCurrencyCode(obj1?.data[0]?.fld_currency);
          setCustomerValidation(obj1?.data[0]?.fld_customer_validation_using);
          setClientLogo(obj1?.data[0]?.fld_image);
        }
      })
    );
  }, []);

  return (
    <div className="App">
      {/* ✅ Wrap the entire app in ProductProvider */}
      <ProductProvider>
        <Router>
          <Header />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/cart" element={<NewCart />} />
            {/* <Route path="/shop" element={<Shop />} /> */}
            <Route path="/shop" element={<ShopNew />} />
            <Route path="/category/:category" element={<ProductListing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route exact path="/privacy-policy" element={<PrivacyPage />} />
            <Route exact path="/view-invoice-form/:id/:orderid" element={<ViewInvoiceForm />} />
            <Route
              path="/paymentsuccess/:txnid"
              element={
                <ProtectedRoutes isAuth={localStorage.getItem("CustomerData") == null ? false : true}>
                  <PaymentSuccess />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/view-all-orders"
              element={
                <ProtectedRoutes isAuth={localStorage.getItem("CustomerData") == null ? false : true}>
                  <ViewAllOrders />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/customer-profile"
              element={
                <ProtectedRoutes isAuth={localStorage.getItem("CustomerData") == null ? false : true}>
                  <CustomerProfilePage />
                </ProtectedRoutes>
              }
            />
            <Route
              exact
              path="/terms-condition"
              element={<DesignTowTermsConditionPage />}
            />
            <Route
              exact
              path="/cancellation-refund-policy"
              element={<CancellationRefundPolicyPage />}
            />
            <Route
              exact
              path="/delivery-terms"
              element={<ShippingDeliveryTermsPage />}
            />
            <Route exact path="/dashboard" element={<CustomerDashboard />} />
            <Route exact path="/disclaimer" element={<DisclaimerPage />} />
            {/* <Route
              exact
              path="/payment-successful"
              element={<PaymentSuccess />}
            /> */}
            <Route path="/product/:route" element={<ProductDetail />} />
          </Routes>
          <Footer />
        </Router>
      </ProductProvider>
    </div>
  );
}

export default App;
